export default "__VITE_ASSET__1136017c__"